export default function boundaryStatusFilter(DataService) {
	"ngInject";

	const filter = function (org) {
		return DataService.getCompiledBoundaryStatus(org);
	};
	filter.$stateful = true;
	return filter;
}
